import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NotifierMessage, isNotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class NotifierManager {

    constructor(
        private _toastr     : ToastrService,
        private _translate  : TranslateService  
    ) { }

    async show( type: Notifier , value: string | NotifierMessage, params ?: Object): Promise<boolean>
    {
        let text = value
        if ( isNotifierMessage ( text ) )
        {
            try{
                text = await this._translate.get(value, params ).toPromise()
            }catch(error){
                return false
            }
        }
        switch( type ){
            case Notifier.SUCCESS:
                this._toastr.success    ( text )
            break 
            case Notifier.WARNING:
                this._toastr.warning    ( text ) 
            break
            case Notifier.ERROR:
                this._toastr.error      ( text ) 
            break
            case Notifier.INFO:
                this._toastr.info       ( text )
            break
            default:
                this._toastr.show       ( text )
            break; 
        }
        return true

    }    
}
